/**
 * Embedded Components: is this page running as a widget inside a partner's iframe?
 *
 * Decided ONCE, from the URL the page was loaded at, and never re-read: an embedded page can navigate
 * inside the SPA (e.g. to the decline screen) and must stay in embed mode -- memory-only store, no
 * logout redirect, no app chrome -- for the whole life of the page.
 *
 * Deliberately has no imports, so utils/store.ts and utils/service.ts can depend on it without a cycle.
 */
export const EMBED_PATH_PREFIX = "/embed/";

export const EMBED_SIGN_PATH = "/embed/sign";

export const EMBED_EDITOR_PATH = "/embed/editor";

export const IS_EMBED: boolean =
  typeof window !== "undefined" &&
  window.location.pathname.startsWith(EMBED_PATH_PREFIX);

export const isEmbedMode = (): boolean => IS_EMBED;

/**
 * Whether the signer page may offer a download. Always true outside the embed widget (the app keeps its own
 * rules); inside it, the sender's "Download documents" permission decides (on unless switched off).
 */
export const embedAllowsDownload = (signRequest: any): boolean =>
  !IS_EMBED || signRequest?.signRequestConfig?.allowDocumentDownload !== false;
